export enum CalendarBlock {
  Root = 'Calendar',
}
